export default __webpack_public_path__ + "static/media/vending_logo.c99c725e.png";